import { render, staticRenderFns } from "./ProjetoAcaoForm.vue?vue&type=template&id=3c8a3a85&"
import script from "./ProjetoAcaoForm.vue?vue&type=script&lang=js&"
export * from "./ProjetoAcaoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports